import { TAssetOperationTypeEnum } from '@/shared/hooks/use-assets-app-sync-events/use-assets-app-sync-events.types';
import { tagsApi } from '@/shared/redux/api/assets/tags/tags-api';
import { useAppDispatch } from '@/shared/redux/hooks/hooks';

export const useInvalidateTagTags = () => {
  const dispatch = useAppDispatch();

  const invalidateTagTags = (
    operationType: TAssetOperationTypeEnum,
    payload?: any,
  ) => {
    switch (operationType) {
      case TAssetOperationTypeEnum.AssetCreated:
      case TAssetOperationTypeEnum.AssetDeleted:
        dispatch(tagsApi.util.invalidateTags([{ type: 'Tag', id: 'LIST' }]));
        break;
      case TAssetOperationTypeEnum.AssetLinked:
      case TAssetOperationTypeEnum.AssetUnlinked:
        dispatch(
          tagsApi.util.invalidateTags([
            {
              type: 'Tag',
              id: `${payload?.destinationType}:${payload?.destinationId}`,
            },
          ]),
        );
        break;
    }
  };

  return {
    invalidateTagTags,
  };
};
